import React from 'react';
import cn from 'classnames';
import './DeploymentStatus.scss';
import _ from 'lodash';

type NodeAndDeviceDeploymentStatus =
  | 'ONLINE'
  | 'OFFLINE'
  | 'ALL_ONLINE'
  | 'PARTIALLY_OFFLINE'
  | 'ALL_OFFLINE'
  | 'ALL_IDLE'
  | 'ALL_RUNNING'
  | 'PARTIALLY_RUNNING'
  | 'NOTHING_DEPLOYED'
  | 'PARTIALLY_DEPLOYED'
  | 'HAS_ERRORS';

type DeviceStatusProps = {
  status: NodeAndDeviceDeploymentStatus;
  showLabel?: boolean;
  label?: string;
  className?: string;
  capitalize?: boolean;
};

const stoppingStatuses = (status: NodeAndDeviceDeploymentStatus) => {
  return status === 'OFFLINE' || status === 'ALL_OFFLINE' || status === 'HAS_ERRORS';
};

const startingStatuses = (status: NodeAndDeviceDeploymentStatus) => {
  return (
    status === 'PARTIALLY_OFFLINE' ||
    status === 'NOTHING_DEPLOYED' ||
    status === 'PARTIALLY_DEPLOYED' ||
    status === 'PARTIALLY_RUNNING' ||
    status === 'ALL_IDLE'
  );
};

export const DeviceStatus = ({
  status,
  label,
  className,
  showLabel = true,
  capitalize = true,
}: DeviceStatusProps) => {
  return (
    <span className={cn('deploy-status', className)}>
      <span
        className={cn(
          'deploy-status__bulb',
          stoppingStatuses(status) && 'deploy-status__bulb--stopping',
          startingStatuses(status) && 'deploy-status__bulb--starting'
        )}
      />
      {showLabel && (label || status)
        ? capitalize
          ? _.capitalize(label || status)
          : label || status
        : ''}
    </span>
  );
};
